export const gradebookBaseUrl = (academyId: string) => `/admin/academies/${academyId}/grading`;

export const ACADEMY_GRADEBOOK_ADMIN_PATHS = {
  academySubmissions: (academyId: string) => `admin/academies/${academyId}/grading/academy_submissions`,
  coursesWithSubmissions: (academyId: string) => `admin/academies/${academyId}/grading/courses_with_submissions`,
  courseSubmissions: (academyId: string, courseId: string) =>
    `admin/academies/${academyId}/grading/course_submissions/${courseId}`,
  bulkGradeSubmissions: (academyId: string) => `admin/academies/${academyId}/grading/bulk_grade`,
};
